/**
 * Created by Ning Jiang on 10/24/2018.
 */

import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";
import {ReelSymbolStateCreator} from "@nolimitcity/slot-game/bin/core/reelsymbol/ReelSymbolStateCreator";
import {ISymbolStateConfig, StateReelSymbol} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";

export class ImmortalFruitsReelSymbolStateCreator extends ReelSymbolStateCreator {

    constructor() {
        super();
    }

    protected noWinStateCreator(symbol:StateReelSymbol, stateKey:string, stateConfig:ISymbolStateConfig):TimelineSprite | null {
        const stateAnimation:TimelineSprite | null = this.getBasicStateAnimation(symbol, stateKey, stateConfig);
        if(stateAnimation) {
            stateAnimation.tint = 0x555555;
        }
        return stateAnimation;
    }
    /**
     * @inheritDoc
     * @override To implement spine in some of the states with some specific symbols.
     * @param symbol
     * @param stateKey
     * @param stateConfig
     */
    protected getBasicStateAnimation(symbol: StateReelSymbol, stateKey: string, stateConfig: ISymbolStateConfig): TimelineSprite | null {
        //console.log("stateKey",stateKey,symbol.symName)
        const symName: string = symbol.symName,
            landStates: string[] = ["Land"],
            spineStates: string[] = ["Idle"]

        if ((spineStates.indexOf(stateKey) !== -1 || landStates.indexOf(stateKey) !== -1)&& symName[0] == "S" ) {
            const spineTextures: PIXI.spine.core.SkeletonData = GameResources.getSpineAsset(symName+"_spine"),
                spine: PIXI.spine.Spine = new PIXI.spine.Spine(spineTextures);

            return (spine as any);
        }
        return super.getBasicStateAnimation(symbol, stateKey, stateConfig);
    }
}